import { ArrayUtils } from "../../utilities/arrays";
var UserClientService = /** @class */ (function () {
    function UserClientService(tokenClientService) {
        this.tokenClientService = tokenClientService;
        this.subscribersOnUserUpdated = [];
    }
    UserClientService.prototype.reloadUserSync = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.tokenClientService.reloadUser().then(function (x) {
                resolve(undefined);
            });
        });
    };
    UserClientService.prototype.subscribeOnUserUpdate = function (func) {
        this.isListInitialized();
        if (func && typeof func == "function") {
            this.unsubscribeOnUserUpdate(func);
            this.subscribersOnUserUpdated.push(func);
        }
    };
    UserClientService.prototype.unsubscribeOnUserUpdate = function (func) {
        this.isListInitialized();
        var index = ArrayUtils.findIndex(this.subscribersOnUserUpdated, function (x) { return x == func; });
        if (index > -1) {
            this.subscribersOnUserUpdated.splice(index, 1);
        }
    };
    UserClientService.prototype.isListInitialized = function () {
        if (!this.subscribersOnUserUpdated) {
            this.subscribersOnUserUpdated = [];
        }
    };
    return UserClientService;
}());
export { UserClientService };
